import { JSX } from "react/jsx-runtime";
import { LoadState } from "../../constants/enums";
import { IAssignee } from "../taskList/taskList.types";

export interface ITaskBoardState {
  data: ITaskBaord;
  loading: LoadState;
}

export interface ITaskBoardItem {
  id: number | string;
  task_uuid: string;
  type: "project";
  type_name: string;
  type_uuid: string;
  project_manager_uuid: string | null;
  project_manager: string | null;
  title: string;
  description: string | null;
  due_date: string;
  upload_file: string | null;
  // upload_file: JSON | null;
  priority: "HIGH" | "MEDIUM" | "LOW";
  category_name: string | null;
  category_uuid: string | null;
  assignee: IAssignee[];
  time_taken: string | null;
  status: "TODO" | "PROGRESS" | "HOLD" | "COMPLETED" | "ARCHIVE" | "CANCELLED";
  create_ts?: string;
  insert_ts?: string;
  parent_uuid: string;
  billing_company_uuid: string;
  billing_company_branch_name: string | null;
  billing_company_name: string | null;

  is_expanded: number;
}

export interface ITaskBaord {
  assigned_to_id: number | null;
  TODO: ITaskBoardItem[];
  PROGRESS: ITaskBoardItem[];
  HOLD: ITaskBoardItem[];
  COMPLETED: ITaskBoardItem[];
  priority: string | null;
  status: string;
  create_ts?: string;
  insert_ts?: string;
}

export const initialTaskBoardState: ITaskBoardState = {
  data: {
    assigned_to_id: 0,
    TODO: [],
    PROGRESS: [],
    HOLD: [],
    COMPLETED: [],
    priority: null,
    status: "ACTIVE",
  },
  loading: LoadState.NotLoaded,
};
